import React, { useState, useMemo, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { Typography } from '@material-ui/core';
import { Form } from '@unform/web';
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import * as Yup from 'yup';

import { Spinner } from '~/components';
import {
  Input,
  DateTime,
  Autocomplete,
  Combobox,
  Hidden,
} from '~/components/Form';
import { ConfirmationDialogRawNew } from '~/componentsLocal';
import { t } from '~/helpers';
import { deletarClientOperacaoTransferencia } from '~/store/modules/operacaotransferencia/actions';

import * as S from './styles';

export default function CreateOrUpdate({
  reference,
  data,
  create,
  toggleLoading,
}) {
  const dispatch = useDispatch();
  // const [posto, setPosto] = useState(0);
  const [postoDestino, setPostoDestino] = useState(0);
  const { internounidatausuario, formaidfrentistaabast } = useSelector(
    (state) => state.user.configs
  );

  const { client } = useSelector((state) => state.user.profile);
  const { loading, find, params } = useSelector(
    (state) => state.operacaotransferencia
  );

  // ConfirmationDialogRaw o registro do geral
  const [isLoading, setIsLoading] = useState(false);
  const [
    tituloConfirmationDialogRaw,
    setTituloConfirmationDialogRaw,
  ] = React.useState('Deseja excluir o registro');
  const [
    mensagemConfirmationDialogRaw,
    setMensagemConfirmationDialogRaw,
  ] = React.useState('Confirma exclusão do registro?');
  const [
    openConfirmationDialogRaw,
    setOpenConfirmationDialogRaw,
  ] = React.useState(false);
  const [
    valueConfirmationDialogRaw,
    setValueConfirmationDialogRaw,
  ] = React.useState('CLICK-OK');
  const [paramSubmit, setParamSubmit] = React.useState();

  const initials = create ? data : { ...find, ...data };
  const { pathname } = useLocation();

  const isDisabled = useMemo(
    () => !create && pathname === '/operacaotransferencia',
    [create, pathname]
  );

  const [idTipoMovimentacao, setIdTipoMovimentacao] = useState(0);

  useEffect(() => {
    let mounted = true;
    if (mounted && !isEmpty(find)) {
      const { tipomovimentacao } = find;
      if (!create) {
        setIdTipoMovimentacao(tipomovimentacao || 0);
      }
    }
    return function cleanup() {
      mounted = false;
    };
  }, [find]);

  async function handleSubmit(param) {
    try {
      const schema = Yup.object().shape({
        justificativa:
          idTipoMovimentacao !== 0
            ? Yup.string()
                .typeError(t('s.geral.validacao.campoobrigatorio'))
                .required(t('s.geral.validacao.campoobrigatorio'))
                .min(10, t('s.geral.validacao.tamanhominimo').replace('%s', 10))
                .max(
                  300,
                  t('s.geral.validacao.tamanhomaximo').replace('%s', 300)
                )
            : Yup.string().nullable(),
      });
      await schema.validate(param, {
        abortEarly: false,
      });
      const objSend = {
        volumepredeterminadomovimentacao: 0.0,
        modomovimentacao: 0,
        formaidmovimentacao: 0,
        numerologmovimentacao: 0,
        onlinemovimentacao: 0,
        vazaomediamovimentacao: 0,
        vazaomaximamovimentacao: 0,
        codigousuario: '',
        ...initials,
        ...param,
        idterminal: initials.idterminal,
        idproduto: initials.idproduto,
        idcliente: client,
      };
      dispatch(deletarClientOperacaoTransferencia(objSend, params));
    } catch (err) {
      const validationErrors = {};

      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          validationErrors[error.path] = error.message.replace(
            `${error.path} `,
            ''
          );
        });

        reference.current.setErrors(validationErrors);
      }
    }
  }

  const execHandleConfirmar = async (param) => {
    setParamSubmit(param);
    setOpenConfirmationDialogRaw(true);
  };

  async function handleSubmitPegunta(param) {
    // await setIsLoading(true);
    // await execHandleConfirmar(param);
    try {
      const schema = Yup.object().shape({
        justificativa:
          idTipoMovimentacao !== 0
            ? Yup.string()
                .typeError(t('s.geral.validacao.campoobrigatorio'))
                .required(t('s.geral.validacao.campoobrigatorio'))
                .min(10, t('s.geral.validacao.tamanhominimo').replace('%s', 10))
                .max(
                  255,
                  t('s.geral.validacao.tamanhomaximo').replace('%s', 255)
                )
            : Yup.string().nullable(),
      });

      await schema.validate(param, {
        abortEarly: false,
      });

      await setIsLoading(true);
      await execHandleConfirmar(param);
    } catch (err) {
      const validationErrors = {};

      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          validationErrors[error.path] = error.message.replace(
            `${error.path} `,
            ''
          );
        });

        reference.current.setErrors(validationErrors);
      }
    }
  }

  const handleConfirmationDialogRaw = (newValue) => {
    // console.log(newValue);
    setOpenConfirmationDialogRaw(false);
    if (newValue) {
      setValueConfirmationDialogRaw(newValue);
      setIsLoading(false);
      if (newValue === 'CLICK-OK') {
        setIsLoading(true);
        handleSubmit(paramSubmit);
      }
    } else {
      // cancelarAcao();
      setIsLoading(false);
    }
  };

  return (
    <>
      <>
        {' '}
        {/* <> Para confirmação do form */}
        <ConfirmationDialogRawNew
          id="ringtone-menu-confirmar"
          keepMounted
          open={openConfirmationDialogRaw}
          onClose={handleConfirmationDialogRaw}
          valueProp={valueConfirmationDialogRaw}
          mensagem={mensagemConfirmationDialogRaw}
          titulo={tituloConfirmationDialogRaw}
          textoBtnOK="Sim"
          textoBtnCancel="Não"
          modal="sm"
        />
      </>{' '}
      {/* <> Para confirmação do form */}
      {loading ? (
        <div style={{ height: '14rem', width: '50rem' }}>
          <Spinner loading />
        </div>
      ) : (
        <Form
          ref={reference}
          initialData={initials}
          onSubmit={(event) => handleSubmitPegunta(event)}
        >
          <S.Header>
            <Typography variant="h6">
              Exclusão de registro pelo usuário
            </Typography>
          </S.Header>
          {idTipoMovimentacao === 0 ? (
            <>
              <S.Header>
                <Typography variant="h7" color="primary">
                  ATENÇÃO: Este registro é manual
                </Typography>
              </S.Header>
              <Hidden
                name="justificativa"
                label="Justificativa"
                value="Registro é manual"
              />
            </>
          ) : (
            <>
              <S.Header>
                <Typography variant="h7" color="error">
                  ATENÇÃO: Este registro foi gerado pelo terminal
                </Typography>
              </S.Header>
              <Input
                multiline
                name="justificativa"
                label="Justificativa"
                rows={4}
              />
            </>
          )}

          {idTipoMovimentacao === 0 ? (
            <S.Header>
              <Typography variant="h5" color="primary" />
            </S.Header>
          ) : (
            <>
              <Autocomplete
                disabled
                name="idposto"
                label="codigonomeposto"
                url="postoscomboios"
                unique="idposto"
                title={t('s.geral.pontoorigem')}
                getValue={(value) => {
                  // handleChangepostoscomboios(value);
                }}
                filterOptions={(options, { inputValue }) =>
                  options.filter(
                    (opt) =>
                      opt.idposto !== postoDestino &&
                      (opt.label
                        ?.toLowerCase()
                        .includes(inputValue.toLowerCase()) ||
                        opt.nomeposto
                          ?.toLowerCase()
                          .includes(inputValue.toLowerCase()))
                  )
                }
              />

              <Combobox
                disabled
                name="idbico"
                label="bicoprodutobico"
                url="bicos"
                unique="idbico"
                title={t('s.menu.configuracao.bico')}
                hiddens={[{ name: 'idterminal' }, { name: 'idproduto' }]}
                params={{
                  wherefield: 'idposto',
                  valuewherefield: data.idposto,
                  typewherefield: 'EQUALS',
                  fieldlist:
                    'idbico, idterminal, idproduto, bicoprodutobico, tipoproduto, exibemotoristaterminal',
                }}
              />

              <DateTime
                disabled
                time
                name="datahorainicialmovimentacao"
                label={t(
                  's.operacao.abastecimento.datahorainicialmovimentacao'
                )}
              />

              <DateTime
                disabled
                time
                name="datahorafinalmovimentacao"
                label={t('s.operacao.abastecimento.datahorafinalmovimentacao')}
              />

              <Autocomplete
                disabled
                id="idpostodestinomovimentacaotransferencia"
                name="idpostodestinomovimentacaotransferencia"
                label="codigonomeposto"
                url="postoscomboios"
                unique="idposto"
                title={t('s.geral.pontodestino')}
                getValue={(value) => {
                  if (value?.idposto) {
                    setPostoDestino(value.idposto);
                  } else {
                    setPostoDestino(0);
                  }
                }}
                // filterOptions={(options, { inputValue }) =>
                //   options.filter(
                //     (opt) =>
                //       opt.idposto !== posto &&
                //       (opt.label
                //         ?.toLowerCase()
                //         .includes(inputValue.toLowerCase()) ||
                //         opt.nomeposto
                //           ?.toLowerCase()
                //           .includes(inputValue.toLowerCase()))
                //   )
                // }
              />

              <Input
                disabled
                name="encerrantemovimentacaotransferencia"
                type="number"
                label={t(
                  's.operacao.transferencia.encerrantemovimentacaotransferencia'
                )}
              />

              <Input
                disabled
                name="encerranteinicialmovimentacao"
                label={t(
                  's.operacao.abastecimento.encerranteinicialmovimentacao'
                )}
                type="number"
                // getValue={(value) => setInicio(value)}
              />

              <Input
                disabled
                name="encerrantefinalmovimentacao"
                label={t(
                  's.operacao.abastecimento.encerrantefinalmovimentacao'
                )}
                type="number"
                // getValue={(value) => setFim(value)}
              />

              <Input
                disabled
                name="volumemovimentacao"
                label={t('s.operacao.abastecimento.volumemovimentacao')}
                type="number"
              />
            </>
          )}
        </Form>
      )}
    </>
  );
}

CreateOrUpdate.propTypes = {
  reference: PropTypes.objectOf(PropTypes.any).isRequired,
  create: PropTypes.bool.isRequired,
  data: PropTypes.objectOf(PropTypes.any),
};

CreateOrUpdate.defaultProps = {
  data: {},
};
